(function () {
  const STORAGE_KEY = 'firstVisitOverlayClosedAt';
  const COOLDOWN_MS = 72 * 60 * 60 * 1000; // 72時間（3日間）
  const SHOW_DELAY = 500;
  const TRANSITION_DURATION = 300;

  function hasSeenOverlay() {
    try {
      const closedAt = localStorage.getItem(STORAGE_KEY);
      if (!closedAt) return false;
      return (Date.now() - Number(closedAt)) < COOLDOWN_MS;
    } catch (e) {
      return false;
    }
  }

  function markOverlaySeen() {
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (e) {
      // Safari private browsing may throw
    }
  }

  function showOverlay(overlay) {
    overlay.style.display = '';
    overlay.offsetHeight; // force reflow for CSS transition
    overlay.classList.add('is-visible');
    document.body.classList.add('overflow-hidden');
  }

  function closeOverlay(overlay) {
    overlay.classList.remove('is-visible');
    document.body.classList.remove('overflow-hidden');
    setTimeout(function () {
      overlay.style.display = 'none';
    }, TRANSITION_DURATION);
    markOverlaySeen();
  }

  document.addEventListener('DOMContentLoaded', function () {
    const overlay = document.getElementById('first-visit-overlay');
    if (!overlay) return;

    const isDesignMode = typeof Shopify !== 'undefined' && Shopify.designMode;

    if (isDesignMode) {
      showOverlay(overlay);
      return;
    }

    if (hasSeenOverlay()) return;

    const close = function () {
      closeOverlay(overlay);
    };

    const closeX = overlay.querySelector('.fvo-close-x');
    const closeBtn = overlay.querySelector('.fvo-close-btn');
    const backdrop = overlay.querySelector('.fvo-backdrop');

    if (closeX) closeX.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-visible')) {
        close();
      }
    });

    setTimeout(function () {
      showOverlay(overlay);
    }, SHOW_DELAY);
  });
})();
